import React from 'react';

const IntensePomodoroCratePage = () => {
  return (
    <div className="page-shell">
      <div className="page-shell__content section-stack">
        <section className="section-card center-text">
          <div className="eyebrow">Crates.io Registry</div>
          <h1 className="page-title">intense-pomodoro</h1>
          <p className="page-copy" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            A pomodoro timer that can scream at you to make work sessions feel more intense (the opposite of the relaxed/lofi vibe). It also lets users record what they have learned during each work session to help users improve their skills over time.
          </p>
        </section>

        <div className="section-stack">
          <section className="section-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '1.2rem' }}>
              <div>
                <div className="eyebrow">Crate</div>
                <h2 className="page-title" style={{ fontSize: '2.2rem', marginBottom: '0.25rem' }}>intense-pomodoro</h2>
                <p className="page-subtitle" style={{ fontSize: '1.05rem', margin: 0 }}>
                  High-accountability terminal focus timer with built-in skill journaling and brutal motivation.
                </p>
              </div>
              <a
                className="button-link"
                href="https://crates.io/crates/intense-pomodoro"
                target="_blank"
                rel="noopener noreferrer"
                style={{ height: 'fit-content' }}
              >
                View on Crates.io
              </a>
            </div>

            <div className="terminal-line" style={{ display: 'flex', width: '100%', boxSizing: 'border-box', marginTop: '1rem' }}>
              <span style={{ color: 'var(--accent)', marginRight: '0.5rem' }}>$</span>
              <span>cargo install intense-pomodoro</span>
            </div>
          </section>

          <div className="two-column-grid">
            <section className="section-card">
              <h3 className="section-title">High-Intensity Focus</h3>
              <ul className="bullet-list">
                <li>Screams and audio/visual alerts when break time is over or when you try to slack off.</li>
                <li>Zero chill: designed for maximum output and brutal accountability during crunch time.</li>
                <li>Built-in learning journal prompt at the end of every completed session.</li>
                <li>Persistent skill progression log to track what you learned and mastered over weeks and months.</li>
              </ul>
            </section>

            <section className="section-card">
              <h3 className="section-title">How It Works</h3>
              <p className="page-copy">
                Start an intense work session in your terminal simply by running:
              </p>
              <div className="terminal-line" style={{ display: 'flex', width: '100%', boxSizing: 'border-box' }}>
                <span style={{ color: 'var(--accent)', marginRight: '0.5rem' }}>$</span>
                <span>intense-pomodoro</span>
              </div>
              <p className="page-copy" style={{ marginTop: '1rem', marginBottom: 0 }}>
                When the timer dings, the app forces you to log your key learnings before letting you start your break, transforming brute work hours into compounding skill growth.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntensePomodoroCratePage;
